export enum PermissionEnum {
  full = 'FullAccess',
  access = 'TouchPointAccess',
  kioskBuilder = 'TouchPointKioskBuilder',
  mediaManager = 'TouchPointMediaManager',
  offers = 'TouchPointOffers',
  drawings = 'TouchPointCmsDrawings',
}
